import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloud = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	stroke: "currentColor",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.6671 12.6666H6.00043C5.13501 12.6664 4.28669 12.4255 3.55028 11.9709C2.81387 11.5163 2.21838 10.8659 1.83035 10.0923C1.44231 9.31877 1.27703 8.45255 1.35296 7.59047C1.42889 6.72838 1.74305 5.90439 2.26033 5.21057C2.77761 4.51676 3.47763 3.98045 4.28217 3.66158C5.0867 3.34271 5.96406 3.25384 6.8162 3.4049C7.66834 3.55596 8.46168 3.941 9.10759 4.51699C9.75349 5.09298 10.2265 5.83724 10.4738 6.66659H11.6671C12.4627 6.66659 13.2258 6.98266 13.7884 7.54527C14.351 8.10788 14.6671 8.87094 14.6671 9.66659C14.6671 10.4622 14.351 11.2253 13.7884 11.7879C13.2258 12.3505 12.4627 12.6666 11.6671 12.6666Z",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCloud;
